import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-24 px-4 bg-deep-black" data-id="element-78">
      <div className="max-w-3xl mx-auto" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="border-2 border-gold/40 bg-gradient-to-b from-gold/10 to-transparent p-8 md:p-12 rounded-3xl text-center relative overflow-hidden" data-id="element-80">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-64 bg-gold/20 blur-[100px] pointer-events-none" data-id="element-81" />

          <div className="relative z-10" data-id="element-82">
            <div className="w-24 h-24 mx-auto mb-8 relative flex items-center justify-center" data-id="element-83">
              <ShieldIcon className="w-full h-full text-gold absolute inset-0" strokeWidth={1.5} data-id="element-84" />
              <span className="text-4xl font-heading font-bold text-white relative z-10 mt-2" data-id="element-85">
                7
              </span>
            </div>

            <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-86">
              Garantía de 7 Días por Inconvenientes
            </h2>
            <p className="text-xl text-gold font-medium mb-6" data-id="element-87">
              Si tenés algún inconveniente con tu compra en los primeros 7 días,
              te devolvemos todo. Sin burocracia.
            </p>

            <p className="text-smoke/80 leading-relaxed mb-8" data-id="element-88">
              Descargá el pack y empezá a aplicarlo. Si durante los primeros 7
              días tenés cualquier inconveniente técnico o con el acceso al
              material, escribinos y te devolvemos el 100% de tu dinero.
              Queremos que tu experiencia sea impecable de principio a fin.
            </p>

            <div className="inline-flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm font-medium text-white/90 bg-black/50 px-6 py-3 rounded-full border border-white/10" data-id="element-89">
              <span data-id="element-90">✓ Devolución por inconvenientes</span>
              <span className="hidden md:inline" data-id="element-91">·</span>
              <span data-id="element-92">✓ 7 días completos</span>
              <span className="hidden md:inline" data-id="element-93">·</span>
              <span data-id="element-94">✓ 100% del monto</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}